import {mapState} from "vuex";
import {deleteCookie, escape} from "@/helperFunctions";

export default {
	computed: {
		...mapState('vorbasse', {
			currentRoom: 'currentRoom',
			displayName: 'displayName',
			rooms: 'rooms'
		})
	},
	methods:{
		initCustomerSocketEvents()
		{
			const socket = this.$vorbasseSocket.socket;
			const that = this;
			
			setInterval(() => {
				socket.emit('touch');
			},30*1000)
			
			socket.on('system-settings',function(settings){
				that.$store.commit('ux/setSystemSettings', settings);
			});
			
			socket.on('socket-token-data',(data) => {
				if ( data === null || typeof data.displayName === 'undefined' || that.displayName !== data.displayName)
				{
					socket.emit('update-display-name', that.displayName)
				}
				if (data !== null && typeof data.fbId !== 'undefined')
				{
					that.$store.commit('ux/setFacebookId', data.fbId);
				}
			});
			
			socket.on('rooms-changed',(rooms) => {
				this.syncSocketAndStoreRooms(rooms);
			});
			
			socket.on('opened-room', (roomData) => {
				that.$store.commit('vorbasse/setCurrentRoom',roomData);
			});
			
			socket.on('chat-message',(message) => {
				message.message = escape(message.message);
				that.$store.commit('vorbasse/addMessageToCurrentRoom',message);
			});
			
			socket.on('chat-meta-changed',(data) => {
				if(that.currentRoom !== false && that.currentRoom.room === data.room)
				{
					that.$store.commit('vorbasse/updateCurrentRoomPartial',data);
				}
				that.$store.commit('vorbasse/updateRooms',[data]);
			});
			
			socket.on('system-notification',(notification) => {
				if(that.$route.name !== 'oelteltet')
				{
					that.$store.commit('vorbasse/setNotification',escape(notification));
				}
			});
			
			socket.on('meta-event',(event) => {
				that.$store.commit('ux/handleMetaEvent',event);
			});
			
			socket.on('socket-error',(error) => {
				if(typeof error === 'object' && typeof error.code !== 'undefined')
				{
					if(error.code === 429)
					{
						that.$store.dispatch('vorbasse/showPrompt',{
							title: 'Forbindelse afvist',
							prompt: 'Du har forbundet fra for mange steder, du vil blive logget af. Luk dine andre enheder og prøv igen.',
							confirmText: 'Ok - forstået',
							showCancelButton: false
						})
						.then(result => {
							
							deleteCookie('auth-token');
							deleteCookie('whoami');
							deleteCookie('managed');
							deleteCookie('spin-tokens');
							that.$store.commit('vorbasse/reset');
							that.$vorbasseSocket.destroy();
						})
						.catch(error => {
							deleteCookie('auth-token');
							deleteCookie('whoami');
							deleteCookie('managed');
							deleteCookie('spin-tokens');
							that.$store.commit('vorbasse/reset');
							that.$vorbasseSocket.destroy();
						})
					}
				}
			});
		},
		syncSocketAndStoreRooms(rooms)
		{
			const that = this;
			const newRooms = rooms.filter((room) => typeof that.rooms[room] === 'undefined');
			const deletedRooms = Object.keys(that.rooms).filter((room) => rooms.indexOf(room) === -1);
			if(newRooms.length > 0)
			{
				that.$vorbasseSocket.emit('trigger-chat-meta-change',newRooms);
				that.$vorbasseSocket.emit('join-update-on-rooms',newRooms);
			}
			that.$store.commit('vorbasse/deleteRooms',deletedRooms);
		}
	}
}
